
<template>

  <div id="app">
  <b-modal id="modal-1" modal-class="pwd-modal" v-model="showModal" title="Update Password" no-close-on-esc no-close-on-backdrop hide-header-close
    ok-variant cancel-variant hide-footer
       header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant >
     <UpdatePassword :UpdatePasswordUser ="updateUser" :showExit = "showExit" :ReturnURL = "returnUrl"></UpdatePassword>
       <template slot="modal-header" > 
         <div  style="margin: 0 auto;">
        <small class="PopUpTitle w-100 text-center">Update Password</small>
      </div>  
    </template>  
  </b-modal>
  </div>
</template>
<script>
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
import Vue from 'vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant'
import Modal from '@/Common/ModelPop.vue';
import UpdatePassword from  '@/components/DPEBB/Administrator/PasswordModel.vue'
  const PasswordCheck = helpers.regex('alphaNum', /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z0-9])).{8,}$/)
  export default {
    name: 'app',
    components: {
      UpdatePassword:UpdatePassword,
        Modal:Modal,
    },
    data () {
      return {
        showExit:false,
        isModalVisible: true,
        showModal: true,
        PopUpVar:PopUpVariant,
        returnUrl:''
      };
    },
    methods: {
      // showModal() {
      //   this.isModalVisible = !this.isModalVisible;
      // },
      closeModal() {
        this.isModalVisible = false;
      }
    },
      created: function() { 
        this.returnUrl = this.$store.getters.GetReturnUrl;
        this.updateUser = this.$store.getters.GetCurrentUser;
      }
  };
</script>
<style >



.pwd-modal .modal {
    padding: 0 !important;
    padding-left: 0px !important;
    overflow-y: scroll;
}

.pwd-modal .modal-dialog { 
    max-width: 800px;
    height: 280px;
    margin: 0;
    top: 10%;
    bottom: 0;
    left: 30%;
    right: 50%;
    display: flex;
    z-index: 100000;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.modal-open {
    padding: 0 !important;
    padding-left: 0 !important;
    overflow-y: scroll;
}

#modal-1 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* @media (min-width: 992px) {
  .modal .modal-mlg {
    max-width: 90% !important;
    width: 90% !important;;
  }
} */
</style>